module.exports = __webpack_public_path__ + "assets/img/19-59.13dddd35.svg";